<template>
  <div style="display:contents;">
    <b-button v-if="buttonType === 'search'" class="mb-1 mr-1" type="submit" variant="primary" @click="onClick()"><i
        class="fa fa-search"></i>&nbsp;{{ $t('str.search') }}</b-button>
    <b-button v-else-if="buttonType === 'reset_filter'" type="button" variant="secondary" @click="onClick()"><i
        class="fa fa-undo"></i>&nbsp;{{ $t('str.reset-filter') }}</b-button>

    <b-button v-else-if="buttonType === 'add_new'" class="mb-1 mr-1" variant="primary" size="m"><i
        class="fa fa-plus"></i>&nbsp;{{ $t('str.add-new') }}</b-button>
    <b-button v-else-if="buttonType === 'edit'" class="mb-1 mr-1" variant="secondary" size="sm"><i
        class="fa fa-edit"></i>&nbsp;{{ $t('str.edit') }}</b-button>
    <b-button v-else-if="buttonType === 'delete'" class="mb-1 mr-1" variant="danger" size="sm" v-b-modal.confirm_modal
      @click="onClick()">
      <i class="fa fa-trash"></i>&nbsp;{{ $t('str.delete') }}
    </b-button>
    <b-button v-else-if="buttonType === 'view'" class="mb-1 mr-1" variant="secondary" size="sm"><i
        class="fa fa-eye"></i>&nbsp;{{ $t('str.view') }}</b-button>

    <b-button v-else-if="buttonType === 'export'" class="mb-1 mr-1 px-4" type="submit" variant="secondary"
      @click="onClick()" :disabled="exporting"><i v-if="exporting" class="fa fa-spinner fa-spin"></i>&nbsp;{{
      $t('str.export') }}
    </b-button>
    <b-button v-else-if="buttonType === 'broadcast'" class="mb-1 mr-1" variant="secondary" size="sm"
      v-b-modal.broadcast_modal @click="onClick()"><i class="fa fa-bell-o"></i>&nbsp;{{ $t('str.push-notif') }}
    </b-button>
    <b-button v-else-if="buttonType === 'toggle'" class="mb-1 mr-1" type="submit" variant="secondary" size="sm"
      @click="onClick()"><FontAwesomeIcon :icon="'fa-solid ' + (toggle == 0 ? toggleFalseClassIcon : toggleTrueClassIcon)" />&nbsp;{{ (toggle == 0 ? $t(toggleFalseStr) :
      $t(toggleTrueStr)) }}</b-button>

    <b-button v-else-if="buttonType === 'back'" class="mb-1 mr-1" variant="primary" size="sm"><i
        class="fa fa-chevron-left"></i>&nbsp;{{ $t('str.back') }}</b-button>
    <b-button v-else-if="buttonType === 'submit'" class="mb-1 mr-1 px-4" type="submit" variant="primary"><i
        class="fa fa-save"></i>&nbsp;{{ $t('str.submit') }}</b-button>
  </div>
</template>

<script>
export default {
  props: {
    buttonType: '',
    exporting: false,
    published: false,
    toggle: false,
    toggleFalseStr: '',
    toggleTrueStr: '',
    toggleFalseClassIcon: '',
    toggleTrueClassIcon: '',
  },
  methods: {
    onClick() {
      this.$emit('click')
    }
  }
}
</script>